'use client'

import { from, HttpLink } from '@apollo/client'
import { onError } from '@apollo/client/link/error'
import { isArray } from '@apollo/client/utilities'
import {
  ApolloClient,
  ApolloNextAppProvider,
  InMemoryCache,
} from '@apollo/experimental-nextjs-app-support'

import { PropsWithChildren } from 'react'

import { customToast } from '../react-toast'

// error link
const errorLink = onError(({ graphQLErrors, networkError }) => {
  // graph ql error
  if (graphQLErrors) {
    graphQLErrors.forEach(({ message, ...rest }: any) => {
      if (isArray(rest.extensions?.originalError?.message)) {
        const msg = `${JSON.parse(rest.extensions?.originalError?.message?.at(0))?.input.slice(0, 1).toUpperCase()}${JSON.parse(rest.extensions?.originalError?.message?.at(0))?.input.slice(1).replaceAll('_', ' ')} - ${JSON.parse(rest.extensions?.originalError?.message?.at(0))?.message}`

        customToast(msg, 'error')
      } else {
        customToast(message.replace('Exception', ''), 'error')
      }
    })
  }

  // network error
  if (networkError && !graphQLErrors) {
    customToast(networkError.message.replace('Exception', ''), 'error')
  }
})

// make client
const makeClient = () => {
  const httpLink = new HttpLink({
    uri: `${process.env.NEXT_PUBLIC_SERVER_URL}/graphql`,
    credentials: 'include',
  })

  // return
  return new ApolloClient({
    link: from([errorLink, httpLink]),
    cache: new InMemoryCache(),
    defaultOptions: {
      watchQuery: {
        fetchPolicy: 'cache-and-network',
        nextFetchPolicy: 'cache-first',
        notifyOnNetworkStatusChange: true,
      },
      mutate: { awaitRefetchQueries: true },
    },
  })
}

// apollo client provider
export const ApolloClientProvider = ({ children }: PropsWithChildren) => {
  // return
  return <ApolloNextAppProvider makeClient={makeClient}>{children}</ApolloNextAppProvider>
}
